import { DriverWorkflow } from '@symfa-inc/providence-verizon-types';
import { CheckboxOptionType } from 'antd/lib/checkbox';

export const WORKFLOW_OPTIONS: CheckboxOptionType[] = Object.values(
  DriverWorkflow,
).map((value: string) => ({ label: value.replace('_', ' '), value }));
